'use client';

import { Box, Grid } from "@mui/material";
import CardBox from "./CardBox";
import { NewsArticleEntry } from "@/types/contentful";

interface BlogSectionProps {
    newsItems: NewsArticleEntry[];
    basePath?: string;
}

const BlogSection = ({ newsItems, basePath }: BlogSectionProps) => {

    if (!newsItems || newsItems.length === 0) {
        return (
            <Box sx={{ textAlign: 'center', py: 4, color: 'text.secondary' }}>
                No news articles found.
            </Box>
        );
    }

    return (
        <Grid container spacing={4}>
            {newsItems.map((item, index) => (
                <Grid size={{ xs: 12, md: 4 }} key={item.sys?.id || index}>
                    <CardBox article={item.fields} id={item.sys?.id} basePath={basePath} />
                </Grid>
            ))}
        </Grid>
    );
};

export default BlogSection;